module.exports = __webpack_public_path__ + "static/media/indicators.fa1b221c.svg";